module.exports = __webpack_public_path__ + "img/fallen-flower-pot.a275e736.png";